export const LiveScanModel = {   
  clinton: {lat: 41.8709102, lng:-90.184084},
  qc:      {lat:  41.5350474, lng:-90.4997822},
  interval: 20000,
  fetchUrl: "https://mongorest.riverboattracker.com/live/json",
   //"https://us-central1-mdm-qcrt-demo-1.cloudfunctions.net/livescans/json",
  tock: 0,
  minute: 0,
  resetTime: [
    { min: 30, sec: 45}
  ],
  idTime: [
    { min: 59, sec: 45, videoIsFull: false }
  ],
  idPlus15: {
    min: 0,
    sec: 0
  },
  infoWindow: {},
  cameraStatus: {
    showVideo: null,
    showVideoOn: null,
    webcamID: null,
    webcamZoom: 0,
    videoIsFull: false,
    vesselsInRange: [],
    videoIsPassingCloseup: false,
    zoomArray: ["off", "left", "center", "right"],
    zoomMode: 0
  },
  trackerStatus: {
    popupOn: false,
    enabled: null,
    followingId: null,
    obj: null
  },
  listStatus: {
    popupOn: false
  },
  promoSources: [],
  promoIsOn: false,
  labelIndex:0,
  lab:"_ABCDEFGHIJKLMNOPQRSTUVWXYZ*#@&~1234567890abcdefghijklmnopqrstuvwxyz",
  red:"#ff0000",
  region: null,
  rangeCenter: null,
  rangeUpper: null,
  rangeLower: null,
  regionsWatched: [],
  focusPosition:null,
  map1ZoomLevel: 10,
  passagesCollection: null,
  alertpublishCollection: null,
  mapMarkersConfig: null,
  voicepublishCollection: null,
  announcementsCollection: null,
  apubFieldName: null,
  vpubFieldName: null,
  lsLenField: null,
  starterData: null,
  showVideoField: null,
  showVideoOnField: null,
  webcamIDField: null,
  webcamZoomField: null,
  webcamSources: null,
  videoSource: null,
  videoType: "application/x-mpegURL",
  videoIsOn: false,
  videoProgram: null,
  videoProgramIsOn: false,
  watchedTrackerIsOn: false,
  passengerTrackerIsOn: false,
  manualTrackerIsOn: false,
  vesselsAreInCameraRange: false,
  vesselsArePass: [],
  vesselsAreWatched: [],
  map1: {},
  map2: {},
  map3: {},
  polylines: {},
  mileMarkersList1:[],
  mileMarkerLabels1:[],
  mileMarkersList2:[],
  mileMarkerLabels2:[],
  mileMarkersList3:[],
  mileMarkerLabels3:[],
  rotatingKey: 0,
  passRotKey: 0,
  watchedRotKey: 0,
  numVessels: 0,
  fakeDataIterator: 0,
  passagesList: [{type:"default"}],
  alertsPassenger: [
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
  ],
  alertsAll: [
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
    {apubVesselName: "loading", apubID:"loading", date: new Date()},
  ],
  announcement: {},
  waypoint: {},
  apubID: 0,
  vpubID: 0,
  prevWebcamID: "",
  prevWaypoint: {},
  prevVpubID: 0,
  prevApubID: 0,
  isReload: true,
  news: [ 
    {key: "f00", text: "Welcome to the <em>dashboard</em> page. It's optimized for HD wide screens."}
  ],
  newsKey: 0,
  transponder: {
    step: 0,
    stepMax: 7,
    viewList: []
  },

  //Method to set region data in environment
  initRegion() {
    //console.log("initRegion()/sitename ",starterData.siteID, starterData.siteName);
    //Is dependant on region variable being set on window
    this.region = starterData.siteID;
    this.rangeUpper = starterData.rangeUpper;
    this.rangeLower = starterData.rangeLower;
    this.rangeCenter = starterData.rangeCenter;
    this.sitename = starterData.siteName;
    this.title = starterData.siteName;  //Not going to be used in new version
    this.dashboardSitesID = starterData.siteID;
    this.focusPosition = starterData.siteCenter; 
    this.map1ZoomLevel = starterData.mapZoomLevel;
    this.passagesCollection = "Passages";
    this.alertpublishCollection = "Alertpublish";
    this.voicepublishCollection = "Voicepublish";
    this.announcementsCollection = "Announcements";
    this.apubFieldName = "lastApubID";
    this.vpubFieldName = "lastVpubID";
    this.lsLenField    = "liveScanLength";

    // this.showVideoField = "showClVideo";
    // this.showVideoOnField = "showClVideoOn";
    // this.webcamIDField = "webcamClinton";
    // this.webcamZoomField = "webcamZoomCl";
    this.regionsWatched = ["clinton"]; //Rework vessels to appear by mile

  },

  //Method used by mapper()
  getShipSpriteCoords(course) {
    if(course >=   0 && course <=  15) return [  0,   0];
    if(course >=  16 && course <=  30) return [ 55,   0];
    if(course >=  31 && course <=  45) return [110,   0];
    if(course >=  46 && course <=  60) return [165,   0];
    if(course >=  61 && course <=  75) return [220,   0];
    if(course >=  76 && course <=  90) return [275,   0];
    if(course >=  91 && course <= 105) return [  0,  55];
    if(course >= 106 && course <= 120) return [ 55,  55];
    if(course >= 121 && course <= 135) return [110,  55];
    if(course >= 136 && course <= 150) return [165,  55];
    if(course >= 151 && course <= 165) return [220,  55];
    if(course >= 166 && course <= 180) return [275,  55];
    if(course >= 181 && course <= 195) return [  0, 110];
    if(course >= 196 && course <= 210) return [ 55, 110];
    if(course >= 211 && course <= 225) return [110, 110];
    if(course >= 226 && course <= 240) return [165, 110];
    if(course >= 241 && course <= 255) return [220, 110];
    if(course >= 256 && course <= 270) return [275, 110];
    if(course >= 271 && course <= 285) return [  0, 165];
    if(course >= 286 && course <= 300) return [ 55, 165];
    if(course >= 301 && course <= 315) return [110, 165];
    if(course >= 316 && course <= 330) return [165, 165];
    if(course >= 331 && course <= 345) return [220, 165];
    if(course >= 346)                  return [275, 165];
    else                               return [  0,   0];
  },

  //Assigns data to map objects
  mapper(o, dat, isNew) {
    const m1 = this.map1
    const m2 = this.map2
    const m3 = this.map3
    o.transponderTS  = parseInt(dat.transponderTS);
    o.position = new google.maps.LatLng(dat.liveLastLat, dat.liveLastLon);
    o.lat  = parseFloat(dat.liveLastLat);
    o.lng  = parseFloat(dat.liveLastLon);
    o.id   = parseInt(dat.liveVesselID);
    o.name = dat.liveName;
    o.liveLocation = dat.liveLocation || "Not Calculated";
    o.dir   = dat.liveDirection;
    o.dirImg = o.setDirImg();
    o.speed  = dat.liveSpeed;
    o.course = dat.liveCourse;
    o.imageUrl = dat.imageUrl;
    o.type   = dat.type;
    o.vesselWatchOn = dat.vesselWatchOn;
    o.otherDataLabel = "od"+dat.liveVesselID;
    o.inCameraRange = dat.inCameraRange;
    o.isInCameraRange = dat.isInCameraRange;
        
    //FOR SHIP ICON MOVEMENT
    let coords = this.getShipSpriteCoords(o.course), icon;
    if(dat.vesselWatchOn==true) {
      o.typeIsWatched = true;
      icon = {
        url: "https://storage.googleapis.com/www.clintonrivertraffic.com/images/ship-icon-sprite-yellow.png",
        origin: { x: coords[0], y: coords[1] }, 
        size: {width: 55, height: 55 }
      };
    } else {
      o.typeIsWatched = false;
      icon = {
        url: "https://storage.googleapis.com/www.clintonrivertraffic.com/images/ship-icon-sprite-cyan.png",
        origin: { x: coords[0], y: coords[1] }, 
        size: {width: 55, height: 55 }
      };
    }


    if(isNew) {
      o.mapLabel = this.lab[++this.labelIndex];
      
      if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
        // Map1 uses responsive content based on zoom, map2/map3 always use detailed markers
        const map1Zoom = m1.getZoom();
        const useDetailedForMap1 = map1Zoom >= 13;
        
        o.map1marker = new google.maps.marker.AdvancedMarkerElement({
          position: new google.maps.LatLng(43.116055, -94.679274),
          title: o.name,
          content: useDetailedForMap1 ? this.createDetailedSVGMarker(o) : this.createSimpleLabelMarker(o),
          map: m1
        });
        
        // Map2 and map3 always use detailed SVG markers (they're at zoom levels where icons are appropriate)
        o.map2marker = new google.maps.marker.AdvancedMarkerElement({
          position: new google.maps.LatLng(43.116055, -94.679274),
          title: o.name,
          content: this.createDetailedSVGMarker(o),
          map: m2
        });
        
        o.map3marker = new google.maps.marker.AdvancedMarkerElement({
          position: new google.maps.LatLng(43.116055, -94.679274),
          title: o.name,
          content: this.createDetailedSVGMarker(o),
          map: m3
        });
      } else {
        // Fallback to legacy Marker for all three maps
        o.map1marker = new google.maps.Marker({
          position: new google.maps.LatLng(43.116055, -94.679274),
          title: o.name,
          icon: {
            url: icon.url,
            origin: new google.maps.Point(icon.origin.x, icon.origin.y),
            size: new google.maps.Size(icon.size.width, icon.size.height)
          },
          label: {
            text: o.mapLabel,
            color: 'white',
            fontSize: '12px',
            fontWeight: 'bold'
          },
          map: m1
        });
        
        o.map2marker = new google.maps.Marker({
          position: new google.maps.LatLng(43.116055, -94.679274),
          title: o.name,
          icon: {
            url: icon.url,
            origin: new google.maps.Point(icon.origin.x, icon.origin.y),
            size: new google.maps.Size(icon.size.width, icon.size.height)
          },
          label: {
            text: o.mapLabel,
            color: 'white',
            fontSize: '12px',
            fontWeight: 'bold'
          },
          map: m2
        });
        
        o.map3marker = new google.maps.Marker({
          position: new google.maps.LatLng(43.116055, -94.679274),
          title: o.name,
          icon: {
            url: icon.url,
            origin: new google.maps.Point(icon.origin.x, icon.origin.y),
            size: new google.maps.Size(icon.size.width, icon.size.height)
          },
          label: {
            text: o.mapLabel,
            color: 'white',
            fontSize: '12px',
            fontWeight: 'bold'
          },
          map: m3
        });
      }
      // Update position for new markers (works for both APIs)
      o.map1marker.position = o.position;
      o.map2marker.position = o.position;
      o.map3marker.position = o.position;
      o.lastMovementTS = new Date();
      o.liveLastScanTS = new Date(dat.liveLastTS*1000);
      o.lastPassageTS = new Date(parseInt(dat.liveLastTS)*1000);
     } else {
      //If this is update
      // Update position (works for both AdvancedMarkerElement and legacy Marker)
      o.map1marker.position = o.position;
      o.map2marker.position = o.position;
      o.map3marker.position = o.position;
      
      // Update markers - only map1 is responsive to zoom, map2/map3 always use detailed markers
      if (o.map1marker.content) {
        // AdvancedMarkerElement map1 - responsive content
        const currentZoom = m1.getZoom();
        const useDetailedMarkers = currentZoom >= 13;
        
        o.map1marker.content = useDetailedMarkers 
          ? this.createDetailedSVGMarker(o)
          : this.createSimpleLabelMarker(o);
      } else {
        // Legacy Marker map1 - update icon
        o.map1marker.setIcon({
          url: icon.url,
          origin: new google.maps.Point(icon.origin.x, icon.origin.y),
          size: new google.maps.Size(icon.size.width, icon.size.height)
        });
      }
      
      // Map2 and map3 always use detailed SVG markers (update content/icon for watched status changes)
      if (o.map2marker.content) {
        o.map2marker.content = this.createDetailedSVGMarker(o);
      } else {
        o.map2marker.setIcon({
          url: icon.url,
          origin: new google.maps.Point(icon.origin.x, icon.origin.y),
          size: new google.maps.Size(icon.size.width, icon.size.height)
        });
      }
      
      if (o.map3marker.content) {
        o.map3marker.content = this.createDetailedSVGMarker(o);
      } else {
        o.map3marker.setIcon({
          url: icon.url,
          origin: new google.maps.Point(icon.origin.x, icon.origin.y),
          size: new google.maps.Size(icon.size.width, icon.size.height)
        });
      }
      //o.map1marker.setMap(m1)
      //o.map2marker.setMap(m2)

      if(o.speed>1.9) { //If transponder reported movement...
        if((o.lng != o.prevLng) || (o.lat != o.prevLat)) { //...did its location change?           
          //Yes means the transponder report is current. Update time value.
          let now = Date.now()          
          o.lastMovementTS.setTime(now)
          o.isMoving = true
          //Reported speed with no position change means stale data. Don't update time value.
        } else {
          o.isMoving = false
        }
      } //0 speed & 0 movement is ok. Just means vessel is idle
      o.prevLat = o.lat
      o.prevLng = o.lng
    }
    return new Promise( (resolve, reject)=>{
      //console.log("mapped obj:", o)
      resolve(o)
    })
    
  },

  // Load shared marker configuration from JSON file
  async loadMapMarkersConfig() {
    if (!this.mapMarkersConfig) {
      try {
        const response = await fetch('/shared/map-markers.json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.mapMarkersConfig = await response.json();
      } catch (error) {
        console.error('Error loading map markers config:', error);
        // Fallback to empty config if loading fails
        this.mapMarkersConfig = {
          waypointLines: [],
          mileMarkers: [],
          markerSettings: {
            mileMarkerStrokeColor: "#34A16B",
            mileMarkerStrokeWeight: 2,
            zoomThresholdForLabels: 12
          }
        };
      }
    }
    return this.mapMarkersConfig;
  },

  // Create waypoint lines from shared configuration
  createWaypointLines() {
    if (!this.mapMarkersConfig || !this.mapMarkersConfig.waypointLines) {
      return {};
    }
    
    const polylines = {};
    this.infoWindow = new google.maps.InfoWindow();
    
    this.mapMarkersConfig.waypointLines.forEach(line => {
      // Create polylines for each map
      polylines[line.name + '1'] = new google.maps.Polyline({
        path: line.path,
        strokeColor: line.strokeColor,
        strokeWeight: line.strokeWeight
      });

      polylines[line.name + '1'].addListener('mouseover', (e)=>{
        this.infoWindow.setContent(line.label);
        this.infoWindow.setPosition(e.latLng);
        this.infoWindow.open(this.map1);    
      });

      polylines[line.name + '1'].addListener('mouseout', ()=>{
        this.infoWindow.close();
      }); 

      
      polylines[line.name + '2'] = new google.maps.Polyline({
        path: line.path,
        strokeColor: line.strokeColor,
        strokeWeight: line.strokeWeight
      });
      
      polylines[line.name + '3'] = new google.maps.Polyline({
        path: line.path,
        strokeColor: line.strokeColor,
        strokeWeight: line.strokeWeight
      });
    });
    
    return polylines;
  },

  toggleMarkerLabels() {
      let zoom = this.map1.getZoom()
      const isVisible = zoom >= 12;
      console.log("map1 zoom is now", zoom)
      //iterate over markers and handle visibility for both marker types
      for(let i=0, len=this.mileMarkerLabels1.length; i<len; i++) {
         const marker = this.mileMarkerLabels1[i];
         if (marker.setVisible) {
           // Legacy Marker API
           marker.setVisible(isVisible);
         } else {
           // AdvancedMarkerElement API
           marker.map = isVisible ? this.map1 : null;
         }
      }
   },

  // Create simple label marker content for low zoom levels
  createSimpleLabelMarker(vessel) {
    const textColor = vessel.typeIsWatched ? 'yellow' : 'cyan'; // Gold for watched, cyan for normal
    const bgColor = '#000000'; // Black text
    
    const markerElement = document.createElement('div');
    markerElement.innerHTML = `
      <div class="vessel-simple-marker" style="
        background: ${bgColor};
        color: ${textColor};
        width: 18px;
        height: 18px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        border: 1px solid #000;
        box-shadow: 0 1px 2px rgba(0,0,0,0.3);
        font-family: 'Merriweather Sans', sans-serif;
      ">${vessel.mapLabel}</div>
    `;
    return markerElement;
  },

  // Create detailed SVG marker content for high zoom levels
  createDetailedSVGMarker(vessel) {
    const fillColor = vessel.typeIsWatched ? 'yellow' : 'cyan';
    
    const markerElement = document.createElement('div');
    markerElement.innerHTML = `
      <div class="vessel-marker ${vessel.typeIsWatched ? 'watched' : 'normal'}">
        <div class="vessel-icon" style="transform: rotate(${vessel.course}deg); transform-origin: center;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="60" viewBox="10 0 20 60">
            <polygon points="20,0 10,20 10,60 30,60 30,20" fill="${fillColor}" stroke="black" stroke-width="2"/>
            <text x="20" y="40" text-anchor="middle" font-size="14" font-weight="bold" fill="black" transform="rotate(${360 - vessel.course}, 20, 35)">${vessel.mapLabel}</text>
          </svg>
        </div>
      </div>
    `;
    return markerElement;
  },



  async initalizeMap(mapCenter, zoom = null) {
    // Use provided zoom or fall back to starterData zoom
    const mapZoom = zoom || this.starterData.mapZoomLevel;
    
    //create maps
    this.map1 = new google.maps.Map(
      document.getElementById("map1"), 
      {
        zoom: mapZoom, 
        center: mapCenter, 
        mapTypeId: 'terrain',
        disableDefaultUI: true,
        styles: this.mapStyles,
        mapId: "639db763db0313abcac4f93b" // Add your dashboard Map ID here
      }
    );
    this.map2 = new google.maps.Map(
      document.getElementById("map2"), 
      {
        zoom: 14, 
        center: mapCenter, 
        mapTypeId: "hybrid",
        disableDefaultUI: true,
        mapId: "639db763db0313abcac4f93b" // Add your dashboard Map ID here
      }
    )
    this.map3 = new google.maps.Map(
      document.getElementById("map3"), 
      {
        zoom: 14, 
        center: mapCenter, 
        mapTypeId: "hybrid",
        disableDefaultUI: true,
        mapId: "639db763db0313abcac4f93b" // Add your dashboard Map ID here
      }
    )
    
    // Load shared marker configuration and create waypoint lines
    await this.loadMapMarkersConfig();
    this.polylines = this.createWaypointLines();
    
    // Set waypoint lines on all maps
    Object.keys(this.polylines).forEach(key => {
      if (key.endsWith('1')) {
        this.polylines[key].setMap(this.map1);
      } else if (key.endsWith('2')) {
        this.polylines[key].setMap(this.map2);
      } else if (key.endsWith('3')) {
        this.polylines[key].setMap(this.map3);
      }
    });

    this.map1.setCenter(this.focusPosition);     
  
    //Add mile marker lines
    const dat = this.mapMarkersConfig.mileMarkers;

    //Reworked 6/22/25 to add infoWindow on hover
    if(this.mileMarkersList1.length == 0) {
      this.infoWindow = new google.maps.InfoWindow();
      for(let i=0, len=dat.length; i<len; i++) {         
         const label = "Mile " + dat[i].id;
         // const infoWindowHTML = `<div style="
         // background-color: #2e7d32;
         // color: #fff;
         // padding: 6px 12px;
         // border: 2px solid white;
         // border-radius: 8px;
         // font-size: 14px;
         // font-weight: bold;
         // text-align: center;
         // font-family: sans-serif;
         // ">
         // ${label}
         // </div>`;        
         const polyline = new google.maps.Polyline({
                name: "Mile "+dat[i].id,            
                path: [
                    {lat: dat[i].latA, lng: dat[i].lngA},
                    {lat: dat[i].latB, lng: dat[i].lngB}
                ],
                strokeColor: "#34A16B",
                strokeWeight: 2,
                map: this.map1
            });
  
         this.mileMarkersList1.push(polyline);
        
         this.mileMarkersList2.push(
            new google.maps.Polyline({
                name: "Mile "+dat[i].id,            
                path: [
                    {lat: dat[i].latA, lng: dat[i].lngA},
                    {lat: dat[i].latB, lng: dat[i].lngB}
                ],
                strokeColor: "#34A16B",
                strokeWeight: 2,
                map: this.map2
            })
        )
        
        this.mileMarkersList3.push(
            new google.maps.Polyline({
                name: "Mile "+dat[i].id,            
                path: [
                    {lat: dat[i].latA, lng: dat[i].lngA},
                    {lat: dat[i].latB, lng: dat[i].lngB}
                ],
                strokeColor: "#34A16B",
                strokeWeight: 2,
                map: this.map3
            })
        )
        let markerLabel1;
        if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
          // Use new AdvancedMarkerElement
          const markerElement = document.createElement('div');
          const markerString = dat[i].id.toString();
          markerElement.innerHTML = `
            <div class="mile-marker-label" data-mile="${dat[i].id}">${markerString[0]}
            ${markerString[1]}
            ${markerString[2]}
            </div>
          `;
          
          markerLabel1 = new google.maps.marker.AdvancedMarkerElement({
            position: {lat: dat[i].latA, lng: dat[i].lngA },
            title: "Mile "+dat[i].id,
            content: markerElement,
            map: null // Initially hidden
          });
        } else {
          // Fallback to legacy Marker
          markerLabel1 = new google.maps.Marker({
            position: {lat: dat[i].latA, lng: dat[i].lngA },
            title: "Mile "+dat[i].id,
            icon: {
              url: "https://storage.googleapis.com/www.clintonrivertraffic.com/images/green.png",
              labelOrigin: new google.maps.Point(24, 15),
              scaledSize: new google.maps.Size(50, 50)
            },
            label: {
              text: String(dat[i].id),
              color: 'white',
              fontSize: '12px',
              fontWeight: 'bold'
            },
            visible: false,
            map: this.map1
          });
        }
        
        this.mileMarkerLabels1.push(markerLabel1)
        
        let markerLabel2;
        if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
          // Use new AdvancedMarkerElement
          const markerElement2 = document.createElement('div');
          const markerString2 = dat[i].id.toString();
          markerElement2.innerHTML = `
            <div class="mile-marker-label" data-mile="${dat[i].id}">${markerString2[0]}
              ${markerString2[1]}
              ${markerString2[2]}
            </div>
          `;
          
          markerLabel2 = new google.maps.marker.AdvancedMarkerElement({
            position: {lat: dat[i].latA, lng: dat[i].lngA },
            title: "Mile "+dat[i].id,
            content: markerElement2,
            map: this.map2
          });
        } else {
          // Fallback to legacy Marker
          markerLabel2 = new google.maps.Marker({
            position: {lat: dat[i].latA, lng: dat[i].lngA },
            title: "Mile "+dat[i].id,
            icon: {
              url: "https://storage.googleapis.com/www.clintonrivertraffic.com/images/green.png",
              labelOrigin: new google.maps.Point(24, 15),
              scaledSize: new google.maps.Size(50, 50)
            },
            label: {
              text: String(dat[i].id),
              color: 'white',
              fontSize: '12px',
              fontWeight: 'bold'
            },
            map: this.map2
          });
        }
        
        this.mileMarkerLabels2.push(markerLabel2)

        let markerLabel3;
        if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
          // Use new AdvancedMarkerElement
          const markerElement3 = document.createElement('div');
          const markerString3 = dat[i].id.toString();
          markerElement3.innerHTML = `
            <div class="mile-marker-label" data-mile="${dat[i].id}">${markerString3[0]}
            ${markerString3[1]}
            ${markerString3[2]}
            </div>
          `;
          
          markerLabel3 = new google.maps.marker.AdvancedMarkerElement({
            position: {lat: dat[i].latA, lng: dat[i].lngA },
            title: "Mile "+dat[i].id,
            content: markerElement3,
            map: this.map3
          });
        } else {
          // Fallback to legacy Marker
          markerLabel3 = new google.maps.Marker({
            position: {lat: dat[i].latA, lng: dat[i].lngA },
            title: "Mile "+dat[i].id,
            icon: {
              url: "https://storage.googleapis.com/www.clintonrivertraffic.com/images/green.png",
              labelOrigin: new google.maps.Point(24, 15),
              scaledSize: new google.maps.Size(50, 50)
            },
            label: {
              text: String(dat[i].id),
              color: 'white',
              fontSize: '12px',
              fontWeight: 'bold'
            },
            map: this.map3
          });
        }
        
        this.mileMarkerLabels3.push(markerLabel3)  
      }
      this.map1.addListener('zoom_changed', () => {
        // Use requestAnimationFrame for immediate, smooth updates
        requestAnimationFrame(() => {
          const zoom = this.map1.getZoom();
          
          // Update mile marker labels
          this.toggleMarkerLabels();
          
          // Update vessel markers on map1 only (map2/map3 always use detailed markers)
          const useDetailedMarkers = zoom >= 13;
          
          if (typeof liveScans !== 'undefined' && liveScans.length) {
            liveScans.forEach(vessel => {
              if (vessel.map1marker && vessel.map1marker.content) {
                vessel.map1marker.content = useDetailedMarkers 
                  ? this.createDetailedSVGMarker(vessel)
                  : this.createSimpleLabelMarker(vessel);
              }
            });
          }
        });
      });      
    }
    google.maps.event.addListener(this.infoWindow, 'domready', () => {
      //Style in infoWindow to look like a mile marker sign.
      const iw = document.querySelector('.gm-style-iw');
      if (iw) {
         iw.style.backgroundColor = '#2e7d32'; // Green background
         iw.style.border = '2px solid white';
         iw.style.borderRadius = '8px';
         iw.style.color = '#fff';
         iw.style.padding = '6px 12px';
         iw.style.fontWeight = 'bold';
         iw.style.textAlign = 'center';
         iw.style.fontFamily = 'sans-serif';
      }
        // Hide the default close button
      const closeBtn = iw?.nextSibling;
      if (closeBtn && closeBtn.tagName === 'BUTTON') {
         closeBtn.style.display = 'none';
      }

   });

    //After building maps, init the db
    initLiveScan();
    
  }

}

